import { render, staticRenderFns } from "./userTzzh.vue?vue&type=template&id=2fb7ca7a&scoped=true&"
import script from "./userTzzh.vue?vue&type=script&lang=js&"
export * from "./userTzzh.vue?vue&type=script&lang=js&"
import style0 from "./userTzzh.vue?vue&type=style&index=0&id=2fb7ca7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7ca7a",
  null
  
)

export default component.exports